import React, { useEffect } from "react";
import "./DisbursalWaiting.scss";
import yellowTick from "../images/yellow-tick.png";
import creditTime from "../images/2to4.png";
import { ReactComponent as StarfinLogo } from "../images/stashfin-logo.svg";
import GooglePlay from "../images/google-play.png";
import AppStore from "../images/app-store.png";

function DisbursalWaiting() {
  useEffect(() => {
    const themeMetaTag = document.querySelector('meta[name="theme-color"]');
    const previousColor = themeMetaTag?.getAttribute("content");
    if (themeMetaTag) {
      themeMetaTag.setAttribute("content", "#FFF6D8");
    }
    return () => {
      if (themeMetaTag && previousColor) {
        themeMetaTag.setAttribute("content", previousColor);
      }
    };
  }, []);

  return (
    <div className="disbursal-waiting-page">
      <div className="hero">
        <div className="title-row">
          <h1>
            Application
            <br />
            Successful!
          </h1>
          <div className="tick-badge">
            <img src={yellowTick} alt="" width={88} height={88} />
          </div>
        </div>
        <img
          src={creditTime}
          alt="Loan amount will be credited to your account in 2 to 4 hours."
          className="credit-banner"
        />
      </div>
      <div className="unlock-info-welcome-back final-logo-container" style={{marginTop: 20}}>
        <p className="title">
          Download Stashfin app to <br /> manage your loan better
        </p>
        <div className="logo-links">
          <StarfinLogo className="logo" />
          <div className="download-links">
            <a href="https://stash.page.link/68s3" target="_blank" rel="noreferrer">
              <img src={AppStore} alt="App Store" />
            </a>
            <a href="https://stash.page.link/68s3" target="_blank" rel="noreferrer">
              <img src={GooglePlay} alt="Play Store" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DisbursalWaiting;
